import autoComplete from '@tarekraafat/autocomplete.js';
import { getAbsoluteUrl } from '../utility/url';
import { select } from '../utility/dom';
export default (params) => {
    const searchControl = select(params.INPUT).first;
    if (!searchControl) {
        return;
    }
    const form = select(params.FORM).first;
    if (!form) {
        return;
    }
    const formUrl = form.getAttribute('action');
    if (!formUrl) {
        throw new Error('Autocomplete: missing URL');
    }
    const searchUrl = new URL(getAbsoluteUrl(formUrl));
    form.addEventListener('submit', event => {
        event.preventDefault();
    });
    const sb = new autoComplete({
        selector: params.INPUT,
        data: {},
        minChars: 1,
        source: (term, suggest) => {
            const options = {
                headers: new Headers()
            };
            options.headers.append('X-Requested-With', 'XMLHttpRequest');
            searchUrl.searchParams.set('s', term);
            fetch(searchUrl.href, options)
                .then(response => response.json())
                .then(json => {
                const suggestions = json;
                suggest(suggestions);
            });
        },
        renderItem: (item, search) => {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            const re = new RegExp(`(${search.split(' ').join('|')})`, 'gi');
            const rp = '<span class="em">$1</span>';
            return (`<div class="autocomplete-suggestion" data-href="${item.permalink}">
					<article class="search-result">'
						<a href="${item.permalink}">
							<h3 class="sr-title">${item.title.replace(re, rp)}</h3>
							<div class="sr-meta">${item.categories.join(' > ')}</div>
						</a>
					</article>
				</div>`);
        },
        onSelect: (e, term, item) => {
            e.preventDefault();
            document.location.href = item.dataset.href;
        }
    });
};
